// extracted by mini-css-extract-plugin
module.exports =  {"menu":"MultiDropdown-module__menu--W9CpJ","menuItem":"MultiDropdown-module__menuItem--p1ac_"};